// extracted by mini-css-extract-plugin
export const link = "LinkToForm-module--link--24Xfj";
export const withRhombus = "LinkToForm-module--withRhombus--3E45p";